<template>
  <div class="product__cans-pack-selector__inner">
    <slot
      :item="item"
      :link="packLink"
      :linked="linked"
      :select="select"
      :activate="activate"
      :price="price"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { cansOptionSelect } from '../../helpers/cans-option-select'
import { hasSellingPlan, matchAllocation, sellingPlanIndex } from '../../helpers/cans-per-can-price'
import { useProductStore } from '../../pinia/ProductStore'

export default {
  name: 'CansPackSelector',

  mixins: [cansOptionSelect],

  itemClass: 'product__cans-pack-selector__item',

  computed: {
    ...mapState(useProductStore, ['selectedSellingPlan']),

    selectedPlanIndex () {
      const packPosition = this.cansSelection?.packPosition
      const activeCell = this.cell(packPosition, this.selectedCansOptions[packPosition])
      return sellingPlanIndex(activeCell?.allocations, this.selectedSellingPlan)
    },
  },

  methods: {
    packLink (position, optionValueId) {
      if (!this.cansLive) return {}

      const cell = this.cansCell(position, optionValueId)
      return { ...this.link(position, optionValueId), 'aria-disabled': cell && !cell.available ? 'true' : null }
    },

    price (position, optionValueId) {
      if (!this.cansLive) return {}

      const cell = this.cansCell(position, optionValueId)
      const allocation = cell && hasSellingPlan(this.selectedSellingPlan)
        ? matchAllocation(cell.allocations, this.selectedSellingPlan, this.selectedPlanIndex)
        : null
      return { textContent: allocation?.perCanText || cell?.perCanText || '' }
    },
  },
}
</script>
